import React from 'react'
import { Helmet } from 'react-helmet-async'

const AboutPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>About Us | FGA Prestige</title>
        <meta name="description" content="Learn about FGA Prestige's heritage and commitment to luxury fashion and lifestyle. Discover our story of excellence in bespoke services and premium experiences." />
        <link rel="canonical" href="https://fgaprestige.com/about" />
        <meta property="og:title" content="About Us | FGA Prestige" />
        <meta property="og:description" content="Learn about FGA Prestige's heritage and commitment to luxury fashion and lifestyle. Discover our story of excellence in bespoke services and premium experiences." />
        <meta property="og:url" content="https://fgaprestige.com/about" />
        <meta property="og:image" content="/Logo/Logo_Black.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige About Us" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us | FGA Prestige" />
        <meta name="twitter:description" content="Learn about FGA Prestige's heritage and commitment to luxury fashion and lifestyle. Discover our story of excellence in bespoke services and premium experiences." />
        <meta name="twitter:image" content="/Logo/Logo_Black.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "About FGA Prestige",
            "description": "Learn about FGA Prestige's heritage and commitment to luxury fashion and lifestyle. Discover our story of excellence in bespoke services and premium experiences.",
            "url": "https://fgaprestige.com/about",
            "publisher": {
              "@type": "Organization",
              "name": "FGA Prestige",
              "url": "https://fgaprestige.com"
            }
          })}
        </script>
      </Helmet>
      
      <main className="min-h-screen">
        <div className="fga-section">
          <div className="fga-container">
            <h1 className="fga-title">About Us</h1>
            <p className="fga-paragraph">About page content will be migrated here.</p>
          </div>
        </div>
      </main>
    </>
  )
}

export default AboutPage